import { connect } from "react-redux";
import actionCreators from "../redux/actionCreators";
import { getFinalReadOnlyMode, getReadOnlyMode } from "../redux/getReadOnlyMode";
import { getActiveDocumentId } from "../redux/selectors";
import ReadOnlyIndication from "./readOnlyIndication";
import { getActiveDocumentType } from "Areas/Sidebar/Documents/redux/selectors";
const mapStateToProps = (state) => ({
    readOnlyMode: getReadOnlyMode(state),
    finalReadOnlyMode: getFinalReadOnlyMode(state),
    activeDocumentId: getActiveDocumentId(state),
    activeDocumentType: getActiveDocumentType(state)
});
const mapDispatchToProps = (dispatch) => ({
    onSetReadOnlyMode: (documentId, readOnlyMode) => dispatch(actionCreators.setReadOnlyMode(documentId, readOnlyMode))
});
export default connect(mapStateToProps, mapDispatchToProps)(ReadOnlyIndication);
